import {
  NavBarWrapper,
  NavBarMenuIconWrapper,
  NavBarMenuWrapper,
  NavBarMenu,
  NavBarLogo,
  NavBarMenuTextWrapper,
  NavBarMenuText,
  NavBarCartContainer,
  NavBarCartLogo,
} from "./NavBarStyled";
import Icon from "../../../Assets/Image/NavBar/Logo.svg";
import Cart from "../../../Assets/Image/NavBar/Cart.svg";
import Menu from "../../../Assets/Image/NavBar/Menu.svg";
import NavBarViewModel from "./NavBarViewModel";
import { useMediaQuery } from "@mui/material";

const NavBar = () => {
  const { menus } = NavBarViewModel();
  const isTablet = useMediaQuery("(min-width:744px)");
  return (
    <NavBarWrapper>
      <NavBarMenuIconWrapper>
        <NavBarMenuWrapper>
          <NavBarMenu src={Menu} />
        </NavBarMenuWrapper>
        <NavBarLogo src={Icon} />
      </NavBarMenuIconWrapper>
      {isTablet && <NavBarMenuTextWrapper>
        {menus.map((menu,index) => (
          <NavBarMenuText key={index}>{menu.title}</NavBarMenuText>
        ))}
      </NavBarMenuTextWrapper>}

      <NavBarCartContainer>
        <NavBarCartLogo src={Cart} />
      </NavBarCartContainer>
    </NavBarWrapper>
  );
};

export default NavBar;
